import stepTypes from 'components/Booking-new/modules/Steps/types';

import bookingService from 'components/Booking-new/services/BookingService';
import getTimestamp from 'utils/getTimestamp';
import isArrayNotEmpty from 'utils/isArrayNotEmpty';

/*
	Appointment data from API:
	{
		appointmentid: "705ccaf4e0c80fa2224f8f8de4ecccdd"
		appointmentstatus: "Inconsistent"
		cancellationuri: "/cancel/705ccaf4e0c80fa2224f8f8de4ecccdd"
		comment: null
		consent_to_data_processing: null
		consent_to_privacy_policy: null
		email: "test@test.com"
		error: null
		errorCode: null
		existingAppoimentIds: null
		firstname: "Test"
		ip_address: null
		lastname: "Test"
		locale: null
		location: "BER"
		message: null
		phone: "+3412343212"
		rescheduleuri: "/reschedule/705ccaf4e0c80fa2224f8f8de4ecccdd"
		saction: "INFO"
		sdate: "2021-08-31"
		service: "INS"
		statusCode: "200"
		stime: "19:30:00.000Z"
		stimeend: "20:00:00.000Z"
		user_agent: null

	}
*/

const getRescheduleStepData = async (paramValue, state) => {
  if (paramValue === null) {
    const steps = state.allSteps.filter(({ type }) => type !== stepTypes.reschedule);

    return { ...state, allSteps: steps };
  }

  const { data, error } = await bookingService.getBookingByAppoitmentId(paramValue);

  if (error || data?.error)
    return {
      ...state,
      isError: true,
    };

  const timestamp = getTimestamp(data?.sdate, data?.stime);
  const allLocations = state?.allSteps?.find(step => step.type === stepTypes.location)?.data?.locations;
  const bookedLocation =
    isArrayNotEmpty(allLocations) && allLocations?.find(location => location.code === data?.location);

  return {
    ...state,
    allSteps: state.allSteps,
    userData: {
      ...state.userData,
      [stepTypes.location]: {
        selectedLocation: bookedLocation,
        isSelected: true,
      },
      [stepTypes.time]: {
        time: timestamp,
      },
      [stepTypes.personalData]: {
        firstName: data?.firstname,
        lastName: data?.lastname,
        email: data?.email,
        phoneNumber: data?.phone,
        ageConsent: true,
        marketingConsent: data?.email_opt_in_step_one,
      },
      [stepTypes.reschedule]: {
        appointment: data,
        service: data,
      },
    },
  };
};

export default getRescheduleStepData;
